import { Box, CardContent, Card } from "@mui/material";

import { CardGrid } from "components/CardGrid";
import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";
import { CardHeader } from "components/formFields/formCards/CardHeader";

import { i18n } from "services/i18nService";

import { UpsServiceRequirementsChecklist } from "views/UpsShipments/UpsShipment/UpsServiceRequirementsChecklist";

export function FrmServiceCode(props) {
  const { disabled, onValueChange, record, rates, isInError } = props;

  function renderOption(props, option) {
    const { id, name, estimatedArrival, cost } = option;
    return (
      <li {...props} key={id}>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ minHeight: "1.2em" }}>
            {name} <b>(${cost})</b>
            <Box sx={{ color: "secondary.main" }}>
              {estimatedArrival} ({i18n("upsShipment.estimated")})
            </Box>
          </div>
        </div>
      </li>
    );
  }
  return (
    <Card variant="outlined">
      <CardContent>
        <CardHeader text={i18n("frmLabel.Service")} />
        <CardGrid>
          <FrmSelectFromObjects
            sendFullObject
            disableClearable
            name="serviceCode"
            disabled={disabled}
            renderOption={renderOption}
            value={
              record.serviceCode
                ? {
                    id: record.saturdayDelivery
                      ? `${record.serviceCode}_saturday`
                      : record.serviceCode,
                  }
                : null
            }
            onValueChange={onValueChange}
            options={rates}
            error={isInError("serviceCode")}
          />
          {disabled && <UpsServiceRequirementsChecklist record={record} />}
        </CardGrid>
      </CardContent>
    </Card>
  );
}
